// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomHeading2 = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: 'url(#clip0_1_67)',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M3.0107 20H0.930703V4.4H3.0107V10.86H12.1307V4.4H14.2107V20H12.1307V12.86H3.0107V20ZM23.1756 24H16.4076V23.376C16.4076 19.668 21.7356 19.656 21.7356 17.376C21.7356 16.248 21.0156 15.516 19.7196 15.516C18.2196 15.516 17.4876 16.428 17.7276 17.976H16.4196C16.2156 15.684 17.4396 14.328 19.7556 14.328C21.8556 14.328 23.0436 15.456 23.0436 17.304C23.0436 20.568 18.2556 20.508 17.9436 22.764H23.1756V24Z',
        fill: 'currentColor',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: 'clip0_1_67',
        },
        /*#__PURE__*/ React.createElement('rect', {
          width: '24',
          height: '24',
          fill: 'white',
        }),
      ),
    ),
  );

export { IconCustomHeading2 };
